"use client";

import useTranslations from '../../hooks/useTranslation';
import useIsMobile from '../../hooks/useIsMobile';
import React, { useEffect, useState } from 'react';
import { Grid, Typography, Box, List, ListItem, IconButton, Paper, Button, Card } from '@mui/material';
import { getDictionary, getField } from '../../utils/translation/translation';
import { getSvg } from '../../utils/svgUtils';
import './style.css'
import Link from 'next/link';
import { useRouter } from 'next/navigation';
import { useNavbar } from '../../contexts/NavbarContext';
import SearchIcon from '@mui/icons-material/Search';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';

export default function BrandedApps() {
    const {
        loading,
        translations,
        supportedLanguages,
        language,
        selectedLanguage,
        handleLanguageChange,
    } = useTranslations();
    const isMobile = useIsMobile();
    const { companyRef, productsRef, blogRef, contactusRef, scrollToSection } = useNavbar();

    const phoneNumber = '+971501286691';
    const isArabic = language === 'arabic';
    const dictionary = getDictionary(translations, 'branded-apps', language);
    const [currentProductIndex, setCurrentProductIndex] = useState(0);



    const products = [
        { title: getField(dictionary, 'our-products', language), subtitle: getField(dictionary, 'branded-apps', language) },
        { title: getField(dictionary, 'our-products', language), subtitle: "Branded Apps" },
    ];
    const router = useRouter();
    const [isMounted, setIsMounted] = useState(false);
    useEffect(() => {
        setIsMounted(true);
    }, []);


    const langCode = language === 'arabic' ? 'ar' : language === 'french' ? 'fr' : 'en';
    const goToCrmAndMarketing = () => {
        if (isMounted) {
            router.push(langCode === 'en' ? `/crm-marketing` : `/${langCode}/crm-marketing`);
        }
    };
    const goToQrDigitalMenu = () => {
        if (isMounted) {
            router.push(langCode === 'en' ? `/qr-digital-menu` : `/${langCode}/qr-digital-menu`);
        }
    };
    const [openIndex, setOpenIndex] = useState<number | null>(null);
    const handleToggle = (index: number) => {
        setOpenIndex(openIndex === index ? null : index);
    };

    const faqsBrandedApps = [
        {
            question: getField(dictionary, 'question1', language),
            answer: getField(dictionary, 'response1', language),
        },
        {
            question: getField(dictionary, 'question2', language),
            answer: getField(dictionary, 'response2', language)
        },
        {
            question: getField(dictionary, 'question3', language),
            answer: `${getField(dictionary, 'response3', language)}`
        },
        {
            question: getField(dictionary, 'question4', language),
            answer: getField(dictionary, 'response4', language),
        },
        {
            question: getField(dictionary, 'question5', language),
            answer: getField(dictionary, 'response5', language),
        },
        {
            question: getField(dictionary, 'question6', language),
            answer: getField(dictionary, 'response6', language),
        },
        {
            question: getField(dictionary, 'question7', language),
            answer: getField(dictionary, 'response7', language),
        },
        {
            question: getField(dictionary, 'question8', language),
            answer: getField(dictionary, 'response8', language),
        },
    ];

    return (<>
        <div style={{ width: isMobile ? "95%" : "85%", margin: "auto", display: "flex", flexDirection: "column", alignItems: "center" }}>
            <div>
                <Grid container spacing={!isMobile && isArabic ? 2 : 4} alignItems="center" padding={isMobile ? "0px " : "25px"} marginTop={isArabic ? '7rem' : "5rem"}>
                    <Grid item xs={12} sm={12} md={6} style={{ order: isArabic ? 2 : 1 }}>
                        <Paper elevation={3} className='paper-style' sx={{ textAlign: isArabic ? 'right' : 'left' }}>
                            <Typography gutterBottom component="h1" variant="h1" width={isMobile ? "100%" : "80%"} fontWeight="bold" fontFamily="Century Gothic" fontSize={isMobile ? "1.5rem" : "2.3rem"}>
                                {getField(dictionary, 'title1', language)}
                            </Typography>
                            {getSvg('arrowUpIcon', { mainPurple: 'var(--accent-primary)' }, { width: '70px', height: '70px' }, { transform: isArabic ? 'translateX(-7rem)' : '' })}
                            <Typography paragraph component="h2" variant="h2" width={isMobile ? "100%" : "80%"} fontFamily="Century Gothic" fontSize={"19px"} sx={{ color: "var(--text-primary)" }}>
                                {getField(dictionary, 'description1', language)}
                            </Typography>
                            <Button
                                variant='contained'
                                sx={{
                                    backgroundColor: "var(--accent-primary)",
                                    marginTop: isMobile ? "2rem" : "3rem",
                                    transition: 'background-color 0.3s ease',
                                    '&:hover': {
                                        backgroundColor: "var(--accent-secondary)",
                                    },
                                }}
                            >
                                <a href="#" rel="prefetch" onClick={() => scrollToSection(contactusRef)} style={{ textDecoration: 'none', color: "white" }}>
                                    {getField(dictionary, 'request-demo', language)}
                                </a>

                            </Button>
                        </Paper>
                    </Grid>
                    <Grid item xs={12} md={6} style={{ order: !isMobile && isArabic ? 1 : 2, }}>
                        <Box display="flex" justifyContent="center">
                            <img src={`${process.env.NEXT_PUBLIC_IMAGE_PATH}/assests/images/branded.png`} width={"90%"} height={"auto"} style={{ maxWidth: "90%" }} alt="Illustration of a home page" />
                        </Box>
                    </Grid>
                </Grid >
                <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%", marginTop: "2rem" }}>
                    <div style={{ display: "flex", flexDirection: "column", alignItems: "center", width: "20%" }}>
                        <div style={{ cursor: 'pointer' }} onClick={goToCrmAndMarketing}>
                            {getSvg('leftArrowIcon', { yellow: 'var(--accent-secondary)' }, { width: isMobile ? "40px" : "50px", height: isMobile ? "40px" : "50px" }, {})}
                        </div>
                        <div style={{ fontSize: isMobile ? "10px" : "1rem", color: "var(--text-secondary)", display: "flex", justifyContent: "center", alignItems: "center", width: isMobile ? "100%" : "95%", marginTop: "10px" }}>     {getField(dictionary, 'crm-marketing', language)} </div>
                    </div>
                    <div
                        style={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            justifyContent: "center",
                            flexGrow: 1,
                            textAlign: "center",
                        }}
                    >
                        <p style={{ color: "var(--text-primary)", fontFamily: "Century Gothic", fontSize: isMobile ? "12px" : "1.2rem", margin: 0, fontWeight: "bold" }}>
                            {products[currentProductIndex].title}
                        </p>
                        <p style={{ color: "var(--text-primary)", fontFamily: "Century Gothic", fontSize: isMobile ? "14px" : "1.7rem", margin: 0, fontWeight: "bold" }}>
                            {products[currentProductIndex].subtitle}
                        </p>
                    </div>

                    <div style={{ display: "flex", flexDirection: "column", alignItems: "center", width: "20%" }}>
                        <div style={{ cursor: 'pointer' }} onClick={goToQrDigitalMenu}>
                            {getSvg('rightArrowIcon', { yellow: 'var(--accent-secondary)' }, { width: isMobile ? "40px" : "50px", height: isMobile ? "40px" : "50px" }, {})}
                        </div>
                        <div style={{ fontSize: isMobile ? "10px" : "1rem", color: "var(--text-secondary)", display: "flex", justifyContent: "center", alignItems: "center", width: isMobile ? "100%" : "95%", marginTop: "10px" }}>      {getField(dictionary, 'qr-digital-menu', language)} </div>

                    </div>

                </div>
                <div style={{ textAlign: "center", color: "var(--accent-primary)", fontWeight: "bold", fontFamily: "Century Gothic", fontSize: isMobile ? "1rem" : "1.5rem", paddingBottom: "3rem" }}>
                    {isArabic ?
                        (<><span style={{ color: "var(--accent-secondary)" }}>!</span> {getField(dictionary, 'ditch-the-fees', language)} </>)
                        :
                        (<>{getField(dictionary, 'ditch-the-fees', language)} <span style={{ color: "var(--accent-secondary)" }}>!</span></>)}
                </div>



            </div>
        </div>
        <div className="section-light-purple-bg" style={{ zIndex: 0 }}>
            <Box
                sx={{

                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    paddingBottom: isMobile ? "0rem" : "0rem",

                }}
            >
                <Grid
                    container
                    spacing={!isMobile && isArabic ? 2 : 4}
                    alignItems="center"
                    justifyContent="center"
                    style={{ width: "85%" }}
                >
                    <Grid
                        item
                        xs={12}
                        md={6}
                        lg={8}
                        style={{
                            order: isArabic ? 2 : 1,
                            display: 'flex',
                            flexDirection: 'column',

                        }}
                    >
                        <Typography
                            gutterBottom
                            component="h3"
                            variant="h3"
                            fontWeight="bold"
                            fontFamily="Century Gothic"
                            fontSize={"25px"}
                            sx={{ color: "var(--text-primary)" }}
                            textAlign={isArabic ? 'right' : "left"}
                            position="relative"
                        >
                            {getField(dictionary, 'title2', language)}
                        </Typography>
                        <Typography
                            paragraph
                            component="h3"
                            variant="h3"
                            fontFamily="Century Gothic"
                            fontSize={"20px"}
                            sx={{ color: "var(--text-primary)" }}
                            textAlign={isArabic ? 'right' : "left"}
                            marginTop={isMobile ? "1rem" : "3rem"}
                        >
                            {getField(dictionary, 'description2', language)}

                        </Typography>
                    </Grid>
                    <Grid item xs={12} md={6} lg={4} style={{ order: !isMobile && isArabic ? 1 : 2, position: 'relative' }}>
                        <Box display="flex" justifyContent="center" alignItems="center" position="relative" style={{ height: isMobile ? '80%' : '70%' }}>
                            {!isMobile && (
                                <div style={{ position: 'absolute', top: "30%", left: "0%", zIndex: 1 }}>
                                    <img
                                        src={`${process.env.NEXT_PUBLIC_IMAGE_PATH}/assests/images/Repeat Grid 31.png`}
                                        alt="grid"
                                        width={"100%"}
                                        height={"100%"}
                                    />
                                </div>
                            )}
                            <img
                                src={`${process.env.NEXT_PUBLIC_IMAGE_PATH}/assests/images/branded-feature.png`}
                                width={isMobile ? "60%" : "60%"}
                                height={isMobile ? "auto" : "auto"}
                                alt="Illustration of a home page"
                                style={{ position: 'relative', zIndex: 2, marginTop: isMobile ? "0" : "10%" }}
                            />

                        </Box>
                    </Grid>

                </Grid >
            </Box>
        </div>
        <div style={{ width: isMobile ? "95%" : "85%", margin: "auto", display: "flex", flexDirection: "column", alignItems: "center" }}>
            <Grid container justifyContent={"space-between"} spacing={!isMobile && isArabic ? 2 : 4} padding={isMobile ? "0px" : "25px"} paddingBottom={isMobile ? "0rem" : "2rem"} marginTop="2rem">

                <Grid
                    item
                    xs={12}
                    md={6}
                    lg={5}
                    style={{
                        order: !isMobile && !isArabic ? 1 : 2,
                        position: 'relative',
                    }}
                >
                    <Box display="flex" justifyContent="center" alignItems="center" position="relative" style={{ height: isMobile ? '80%' : '70%' }}>
                        {!isMobile && (
                            <div style={{ position: 'absolute', top: "-10%", left: "40%", zIndex: 1 }}>
                                <img
                                    src={`${process.env.NEXT_PUBLIC_IMAGE_PATH}/assests/images/grid1.png`}
                                    alt="grid"
                                    width={"70%"}
                                    height={"70%"}
                                />
                            </div>
                        )}
                        <img
                            src={`${process.env.NEXT_PUBLIC_IMAGE_PATH}/assests/images/branded-feature3.png`}
                            width={isMobile ? "60%" : "60%"}
                            height={isMobile ? "auto" : "auto"}
                            alt="Illustration of a home page"
                            style={{ position: 'relative', zIndex: 2, marginTop: isMobile ? "0" : "10%" }}
                        />
                    </Box>
                </Grid>


                <Grid
                    item
                    xs={12}
                    md={6}
                    lg={7}
                    style={{
                        order: !isMobile && !isArabic ? 2 : 1,
                        display: 'flex',
                        flexDirection: 'column',
                    }}
                >
                    <Typography
                        gutterBottom
                        component="h3"
                        variant="h3"
                        fontWeight="bold"
                        fontFamily="Century Gothic"
                        fontSize={"25px"}
                        sx={{ color: "var(--text-primary)" }}
                        textAlign={isArabic ? 'right' : "left"}
                        position="relative"
                    >
                        {getField(dictionary, 'title3', language)}
                    </Typography>
                    <Typography
                        paragraph
                        component="h3"
                        variant="h3"
                        fontFamily="Century Gothic"
                        fontSize={"20px"}
                        sx={{ color: "var(--text-primary)" }}
                        textAlign={isArabic ? 'right' : "left"}
                        marginTop={isMobile ? "1rem" : "3rem"}
                    >
                        {getField(dictionary, 'description3', language)}
                    </Typography>
                </Grid>
            </Grid>

        </div>

        <div className="section-light-purple-bg" style={{ zIndex: 0 }}>
            <Box
                sx={{

                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    padding: isMobile ? "0px" : "3rem",
                    marginTop: isMobile ? "0" : "2rem",
                    paddingBottom: isMobile ? "0rem" : "0rem",

                }}
            >
                <Grid
                    container
                    spacing={!isMobile && isArabic ? 2 : 4}
                    alignItems="center"
                    justifyContent="center"
                    style={{ width: "85%" }}
                >
                    <Grid
                        item
                        xs={12}
                        sm={6}
                        md={6}
                        lg={7}
                        style={{
                            order: isArabic ? 2 : 1,
                            display: 'flex',
                            flexDirection: 'column',

                        }}
                    >
                        <Typography
                            gutterBottom
                            component="h3"
                            variant="h3"
                            fontWeight="bold"
                            fontFamily="Century Gothic"
                            fontSize={"25px"}
                            sx={{ color: "var(--text-primary)" }}
                            textAlign={isArabic ? 'right' : "left"}
                            position="relative"
                        >
                            {getField(dictionary, 'title4', language)}
                        </Typography>
                        <Typography
                            paragraph
                            component="h3"
                            variant="h3"
                            fontFamily="Century Gothic"
                            fontSize={"20px"}
                            sx={{ color: "var(--text-primary)" }}
                            textAlign={isArabic ? 'right' : "left"}
                            marginTop={isMobile ? "1rem" : "3rem"}
                        >
                            {getField(dictionary, 'description4', language)}

                        </Typography>
                    </Grid>
                    <Grid item xs={12} sm={6} md={6} lg={5} style={{ order: !isMobile && isArabic ? 1 : 2, position: 'relative', marginTop: isMobile ? "2rem" : "" }}>
                        <Box
                            display="flex"
                            flexDirection="column"
                            alignItems="center"
                            justifyContent="center"
                            position="relative"
                            style={{ height: isMobile ? '80%' : '70%' }}
                        >
                            {!isMobile && (
                                <div style={{ position: 'absolute', left: "30%", zIndex: 1 }}>
                                    <img
                                        src={`${process.env.NEXT_PUBLIC_IMAGE_PATH}/assests/images/Repeat Grid 28.svg`}
                                        alt="grid"
                                        loading='lazy'
                                        width={"30%"}
                                        height={"30%"}
                                    />
                                </div>
                            )}

                            <img
                                src={`${process.env.NEXT_PUBLIC_IMAGE_PATH}/assests/images/Group 11063.png`}
                                loading='lazy'
                                width={"100%"}
                                height={"auto"}
                                alt="Additional Illustration"
                                style={{
                                    maxWidth: "60%",
                                    height: 'auto',
                                    position: 'relative',
                                    zIndex: 2,

                                }}
                            />
                            <img
                                src={`${process.env.NEXT_PUBLIC_IMAGE_PATH}/assests/images/inc.png`}
                                loading='lazy'
                                width={"100%"}
                                height={"100%"}
                                alt="Additional Illustration"
                                style={{
                                    maxWidth: "30%",
                                    height: 'auto',
                                    position: 'relative',
                                    zIndex: 4,
                                    marginTop: "-2rem"

                                }}
                            />
                        </Box>
                    </Grid>

                </Grid >
            </Box>

        </div>
        <div style={{ width: isMobile ? "95%" : "85%", margin: "auto", display: "flex", flexDirection: "column", alignItems: "center" }}>
            <Grid container justifyContent={"space-between"} spacing={!isMobile && isArabic ? 2 : 4} padding={isMobile ? "0px" : "25px"} paddingBottom={isMobile ? "0rem" : "2rem"} marginTop="2rem">

                <Grid
                    item
                    xs={12}
                    md={6}
                    lg={5}
                    style={{
                        order: !isMobile && !isArabic ? 1 : 2,
                        position: 'relative',
                    }}
                >
                    <Box display="flex" justifyContent="center" alignItems="center" position="relative" style={{ height: isMobile ? '80%' : '70%' }}>
                        {!isMobile && (
                            <div style={{ position: 'absolute', top: "-10%", left: "30%", zIndex: 1 }}>
                                <img
                                    src={`${process.env.NEXT_PUBLIC_IMAGE_PATH}/assests/images/grid1.png`}
                                    alt="grid"
                                    width={"80%"}
                                    height={"80%"}
                                />
                            </div>
                        )}
                        <img
                            src={`${process.env.NEXT_PUBLIC_IMAGE_PATH}/assests/images/branded-feature3.png`}
                            width={isMobile ? "60%" : "70%"}
                            height={isMobile ? "auto" : "auto"}
                            alt="Illustration of a home page"
                            style={{ position: 'relative', zIndex: 2, marginTop: isMobile ? "0" : "10%" }}
                        />
                    </Box>
                </Grid>


                <Grid
                    item
                    xs={12}
                    md={6}
                    lg={7}
                    style={{
                        order: !isMobile && !isArabic ? 2 : 1,
                        display: 'flex',
                        flexDirection: 'column',
                    }}
                >
                    <Typography
                        gutterBottom
                        component="h3"
                        variant="h3"
                        fontWeight="bold"
                        fontFamily="Century Gothic"
                        fontSize={"25px"}
                        sx={{ color: "var(--text-primary)" }}
                        textAlign={isArabic ? 'right' : "left"}
                        position="relative"
                    >
                        {getField(dictionary, 'title5', language)}
                    </Typography>
                    <Typography
                        paragraph
                        component="h3"
                        variant="h3"
                        fontFamily="Century Gothic"
                        fontSize={"20px"}
                        sx={{ color: "var(--text-primary)" }}
                        textAlign={isArabic ? 'right' : "left"}
                        marginTop={isMobile ? "1rem" : "3rem"}
                    >
                        {getField(dictionary, 'description5', language)}
                    </Typography>
                </Grid>
            </Grid>

        </div>

        <div className="faq-wrapper" style={{ width: isMobile ? "95%" : "100%", margin: "auto", marginTop: "2rem", display: "flex", flexDirection: "column", alignItems: "center" }}>
            <div>
                <Box style={{ width: "100%", display: "flex", justifyContent: isMobile ? "space-between" : "center" }}>
                    <div className='container' style={{ padding: "1rem" }}>
                        <Box className="box-container" sx={{ width: isMobile ? "95%" : "900px" }}>
                            <div style={{ display: "flex", alignItems: "center" }}>
                                <div style={{ display: "flex", alignItems: "center", flexDirection: "column", lineHeight: 1 }}>
                                    <p className='faq-title'>{getField(dictionary, 'faq', language)}  </p>
                                    <p className="fap-under-title" style={{ fontSize: isMobile ? "15px" : "19px" }}> {getField(dictionary, 'what-are-you-looking-for', language)} </p>
                                </div>
                                <div><SearchIcon sx={{ fontSize: "70px", color: "var(--accent-secondary)" }} /> </div>
                            </div>
                            <Grid container spacing={0} alignItems="center" justifyContent="center" marginTop="1rem">
                                <Grid item xs={12} md={5} justifyContent={isMobile ? "center" : "flex-start"}>
                                    <Box >
                                        <div style={{ display: "flex", alignItems: "center", justifyContent: isMobile ? "center" : "flex-start", marginTop: "1rem" }}>
                                            <div >
                                                {getSvg('arrowDownYellowIcon', { yellow: 'var(--accent-secondary)', darkPurple: 'var(--accent-primary)' }, { width: isMobile ? 70 : 100, height: isMobile ? 70 : 100 }, { transform: isMobile ? "translateX(2rem) " : "translateX(3rem)" })}
                                            </div>
                                            <div style={{ marginLeft: "1rem" }}>
                                                <p style={{ fontSize: "15px", color: "var(--text-primary)", fontFamily: "Century Gothic", margin: 0 }}> {getField(dictionary, 'cant-find-what', language)}</p>
                                                <p style={{ width: "90%", fontSize: isMobile ? "15px" : "17px", fontWeight: "bold", color: "var(--text-primary)", fontFamily: "Century Gothic", margin: 0 }}>
                                                    {getField(dictionary, 'we-would-like', language)}
                                                </p>
                                                <div style={{

                                                    marginTop: isMobile ? "2rem" : "4rem",

                                                }} className='chat-container'>
                                                    <span className='whatsapp-container'>
                                                        {getSvg('chattingIcon', { yellow: 'var(--accent-secondary)', darkPurple: 'var(--accent-primary)' }, { width: 60, height: 60 }, { display: "inline-block" })}
                                                        <span><a href={`https://wa.me/${phoneNumber}`} target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none', color: 'inherit' }}>
                                                            {isArabic ?
                                                                (<><span >!</span>    {getField(dictionary, 'chat-with-us', language)} </>)
                                                                :
                                                                (<>   {getField(dictionary, 'chat-with-us', language)} <span >!</span></>)}
                                                        </a></span>
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </Box>
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <Box style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                                        {faqsBrandedApps.map((question, index) => (
                                            <>
                                                <Box key={index} className='quest-box' style={{ direction: isArabic ? 'rtl' : 'ltr', textAlign: isArabic ? 'right' : 'left' }}>
                                                    <div><p className='question' style={{ fontSize: isMobile ? "15px" : "15px" }}>{question.question}</p></div>
                                                    <div>
                                                        <IconButton className='question-icon' onClick={() => handleToggle(index)} aria-label="Open or Close Button">
                                                            {openIndex === index ? <RemoveIcon /> : <AddIcon />}
                                                        </IconButton>
                                                    </div>
                                                </Box>
                                                {openIndex === index && (
                                                    <Box className='answr-box' style={{ direction: isArabic ? 'rtl' : 'ltr', textAlign: isArabic ? 'right' : 'left' }}>
                                                        <p style={{ fontSize: isMobile ? "14px" : "16px", color: "var(--text-primary)", fontFamily: "Century Gothic", margin: 0 }} dangerouslySetInnerHTML={{ __html: question.answer }} />
                                                    </Box>
                                                )}
                                            </>
                                        ))}
                                    </Box>
                                </Grid>
                            </Grid>



                        </Box>
                    </div>
                </Box>
            </div>
        </div>











    </>)
}